import axios from "axios"

// Elimina la URL hardcodeada (http://localhost:4000) de todos los archivos.
// Para cambiar el servidor solo se edita el .env → REACT_APP_API_URL=http://...
const api = axios.create({
  baseURL: process.env.NODE_ENV === "production" ? "" : (process.env.REACT_APP_API_URL || "http://localhost:4000"),
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const url = error.config?.url || ""
    // Si el token venció o es inválido (y no estamos en un endpoint de login), cerrar sesión automáticamente
    if ((status === 401 || status === 403) && !url.includes("/auth/")) {
      localStorage.removeItem("token")
      window.location.href = "/"
    }
    return Promise.reject(error)
  }
)

export default api
